export enum ProcessModes {
    DISCIPLINE = "discipline",
    GENERAL_EMPLOYEE = "generalEmployee",
    GENERAL_CANDIDATE = "generalCandidate",
}
